export default {
  "title": {
    "evolution": "En riesgo (evolución)",
    "distribution": "Histograma índice fatiga",
    "indicators": "Principales indicadores fatiga",
    "ranking": "Ranking de conductores"
  },
  "labels": {
    "driversAtRisk": "Conductores en riesgo (Evolución diaria)",
    "driversAtRiskKpi": "Conductores en riesgo",
    "filterByRisk": "Filtrar por riesgo"
  },
  "selects": {
    "All": "Todos",
    "HasRisk": "En riesgo"
  },
  "buttons": {
    "moreDetails": "Más detalles"
  },
  "graphToolTip": {
    "HasRisk": "En riesgo",
    "indice": "Indice entre",
    "drivers": "conductores"
  },
  "nfa": {
    "previousPeriod": "Período anteriror",
    "thisPeriod": "Este Período",
    "to": "al",
    "underRisk": "Bajo Riesgo total",
    "driverNfa": "Representa el % de conductores / día con nivel de fatiga acumulada en 4 periodos de tiempo seleccionado",
    "nfaText": "Nivel de fatiga acumulada: es un indicador que calcula la probabilidad de ocurrencia de al menos un evento de somnolencia en una jornada de trabajo dentro de las próximas 24 horas. Hay 4 niveles de fatiga acumulada, clasificados en función de las probabilidades de sufrir un evento de somnolencia:",
    "percentageOfNfaOne": "0% a 2% de sufrir un evento de somnolencia en su próxima jornada",
    "percentageOfNfaTwo": "2% a 10% de sufrir un evento de somnolencia en su próxima jornada",
    "percentageOfNfaThree": "10% a 20% de sufrir un evento de somnolencia en su próxima jornada",
    "percentageOfNfaFour": "20% a 100% de sufrir un evento de somnolencia en su próxima jornada",
    "howItGoes": "Como vas respecto a la meta",
    "goal": "Meta",
    "Deviations": "Desviaciones generadas",
    "distribution": "Distribución desviaciones",
    "deviationQuantity": "Cantidad de desviaciones",
    "managmentQuantity": "Cantidad de gestiones para el",
    "managmentQuantityTime": "Cantidad de gestiones a tiempo",
    "driverRanking": "Ranking de conductores",
    "rankinNunber": "N Ranking",
    "driverName": "Nombre conductor",
    "riskPeriod": "Riesgo período",
    "evoulutionRisk": "Evolución % de riesgo nivel fatiga",
    "fatigueLevel": "Nivel de fatiga acumulada",
    "titleMain": "Evolución nivel de fatiga acumulada todas las operaciones"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/fatigue/detailFatigue.js